module.exports = __webpack_public_path__ + "img/20190831135621360截图20190831123840897.ff687dbc.jpg";